var React = require('react');

function Pencil (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0}),React.createElement("g",{"id":"icons","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","strokeLinejoin":"round","key":1},React.createElement("g",{"transform":"translate(-313.000000, -516.000000)","id":"pencil_icn-copy-3","stroke":"#BB0104"},React.createElement("g",{"transform":"translate(313.000000, 516.000000)"},[React.createElement("polygon",{"id":"Stroke-1","points":"13.6574667 3.0324 4.4723 12.2175667 2.02346667 9.76873333 11.2074667 0.583566667","key":0}),React.createElement("polygon",{"id":"Stroke-3","points":"0.5831 13.6571167 4.4716 12.21745 2.02276667 9.76861667","key":1}),React.createElement("polygon",{"points":"9.26765,2.5242 11.7164833,4.97303333","id":"Stroke-7","key":2})])))]);
}

Pencil.defaultProps = {"width":"15px","height":"15px","viewBox":"0 0 15 15","version":"1.1"};

module.exports = Pencil;

Pencil.default = Pencil;
